<div class="reports-box__progress">
  <p class="progress__label">
    {{label}}
    <span class="progress__percentage" *ngIf="showPercentage"
      [ngStyle]="{'color': backgroundColor}">{{percentage}}</span>
  </p>
  <div class="progress__bar" [ngStyle]="{'height.px': progressBarHeight ? progressBarHeight : 20}">
    <span class="bar__fill" [ngStyle]="{'width':percentage , 'background-color': backgroundColor}">
      <span class="progress__value"
        [ngStyle]="{'color': backgroundColor, 'margin-right': value === 0 ? '-30px' : '-45px'}">{{value}}</span>
    </span>
  </div>
</div>
